<template>
	<div
		class="shadow-box recipe"
		:class="{ link: itemUrl }"
		@click="openLink"
	>
		<progressive-image
			:src="itemImage"
		/>
		<div
			class="title-box"
			:class="{ trunced: isTrunced }"
			v-html="itemTitle"
		/>
	</div>
</template>

<script>
export default {
	props: {
		isTrunced: {
			type: Boolean,
			default: false
		},
		itemImage: {
			type: String,
			default: null
		},
		itemTitle: {
			type: String,
			default: null
		},
		itemUrl: {
			type: String,
			default: null
		}
	},

	data () {
		return {
			h: null
		}
	},

	methods: {
		openLink () {
			if (!this.itemUrl) return
			this.$router.push({ path: this.itemUrl })
		}
	}
}
</script>

<style scoped>
.link {
	cursor: pointer;
}
.title-box {
	padding: 7px;
	position: relative;
	line-height: 1.1;
	overflow: hidden;
}

.image {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.title.trunced {
	display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 40px;
    margin-bottom: 7px;
}

.shadow-box {
	height: 99%;
}
</style>
